<template>
  <!-- 来电转接号码选择 -->
  <div class="transfer-operator-select">
    <div class="content">
      <div class="title">{{ title }}</div>
      <el-select
        v-model="selectedType"
        placeholder="请选择"
        style="width: 30%; margin-right: 5%;"
        @change="typeChanged"
      >
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          {{ item.label }}
        </el-option>
      </el-select>
      <el-select
        v-if="selectedType == 'inline'"
        v-model="selectedId"
        clearable
        placeholder="请选择"
        style="width: 65%"
      >
        <el-option
          v-for="item in listData"
          :key="item.serviceNo"
          :label="item.serviceNo + '--' + item.serverName + '--' + item.serverWorkStatusName"
          :value="item.serviceNo"
        >
          {{ item.serviceNo + '--' + item.serverName + '--' + item.serverWorkStatusName }}
        </el-option>
      </el-select>
      <el-input
        v-else-if="selectedType == 'outline'"
        v-model="selectedId"
        clearable
        placeholder="请输入外线号码"
        maxlength="12"
        show-word-limit
        style="width: 60%"
      ></el-input>
      <div class="btn">
        <el-button type="primary" size="small" @click="doSave"> 确定 </el-button>
        <el-button size="small" @click="doClose">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { operatorStatusMap } from '../common';
import { getOperatorsApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'OperatorSelect',
  props: {
    title: {
      type: String,
      required: true,
    },
    operatorStatus: {
      type: Array,
      required: true,
    },
    currStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      typeList: [
        {
          value: 'inline',
          label: '转内线',
        },
        {
          value: 'outline',
          label: '转外线',
        },
      ], // 转接类型列表
      selectedType: 'inline', // 选中的转接类型
      listData: [], // 坐席列表
      selectedId: '', // 选中的坐席id
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /* 获取坐席列表 */
    getList() {
      getOperatorsApi({
        workStatus: this.operatorStatusMap[this.currStatus],
      }).then(({ data }) => {
        this.listData = data;
      });
    },
    /* 切换类型 */
    typeChanged() {
      this.selectedId = '';
    },
    /* 确认 */
    doSave() {
      if (this.selectedType == 'inline') {
        if (!this.selectedId) {
          this.$message.warning('请先选择一个坐席!');
          return;
        }
      } else if (this.selectedType == 'outline') {
        if (!this.selectedId) {
          this.$message.warning('请输入外线号码!');
          return;
        } else if (!/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(this.selectedId)) {
          this.$message.warning('请输入正确的外线号码!');
          return;
        }
      }
      this.$emit('save', this.selectedId, this.selectedType);
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.transfer-operator-select {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.3);
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    width: 350px;
    border: solid 1px #dcdfe6;
    border-radius: 5px;
    padding: 20px 10px 0;
    background: #fff;

    .title {
      margin-bottom: 10px;
    }

    .btn {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
